<template>
  <div ref="captchaStatsGraphs" class="captcha-solving-stats-table-main">
    <div class="captcha-solving-stats-container">
      <div class="captcha-solving-stats-header">
        <div class="captcha-solving-stats-header-column">
          <h1>Solving Satistics</h1>
          <p>Your captcha solves broken down by the numbers.</p>
        </div>
        <div @click="refresh" class="captcha-solving-stats-refresh">
          REFRESH
        </div>
      </div>
      <div class="captcha-solving-stats-variants">
        <div @click="activatePublic">
          <p
            :class="
              publicVariant
                ? 'captcha-solving-active'
                : 'captcha-solving-inactive'
            "
          >
            Public
          </p>
          <div
            v-if="publicVariant"
            class="captcha-solving-stats-active-variant"
          ></div>
        </div>
        <div @click="activatePrivate">
          <p
            :class="
              privateV ? 'captcha-solving-active' : 'captcha-solving-inactive'
            "
          >
            Private
          </p>
          <div
            v-if="privateV"
            class="captcha-solving-stats-active-variant"
          ></div>
        </div>
      </div>

      <div class="captcha-solving-stats-actual-graphs" v-if="publicVariant">
        <div class="captcha-solving-stats-actual-graphs-row">
          <StatsGraph
            :graphData="PublicsolveSpeed"
            head="Solve Speed"
          ></StatsGraph>
          <StatsGraph
            :graphData="PublicfreeSolversGraph"
            head="Free Solvers"
          ></StatsGraph>
        </div>

        <div class="captcha-solving-stats-actual-graphs-row">
          <StatsGraph
            :graphData="PublicavgBidGraph"
            head="Avg Bid"
          ></StatsGraph>
          <StatsGraph
            :graphData="PublicsolversOnlineGraph"
            head="Solvers Online"
          ></StatsGraph>
        </div>
      </div>

      <div class="captcha-solving-stats-actual-graphs" v-else>
        <div class="captcha-solving-stats-actual-graphs-row">
          <StatsGraph
            :graphData="PrivatesolveSpeed"
            head="Solve Speed"
          ></StatsGraph>
          <StatsGraph
            :graphData="PrivatefreeSolversGraph"
            head="Free Solvers"
          ></StatsGraph>
        </div>
        <div class="captcha-solving-stats-actual-graphs-row">
          <StatsGraph
            :graphData="PrivateavgBidGraph"
            head="Avg Bid"
          ></StatsGraph>
          <StatsGraph
            :graphData="PrivatesolversOnlineGraph"
            head="Solvers Online"
          ></StatsGraph>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import StatsGraph from "./StatsGraph";
import { systemStats, avgSpeed } from "../../../../api/graphs";
import moment from "moment";

export default {
  components: {
    StatsGraph,
  },
  data: () => {
    return {
      publicVariant: true,
      privateV: false,
      factoryV: false,

      PublicavgBidGraph: [],
      PublicfreeSolversGraph: [],
      PublicsolversOnlineGraph: [],
      PublicsolveSpeed: [],
      PrivateavgBidGraph: [],
      PrivatefreeSolversGraph: [],
      PrivatesolversOnlineGraph: [],
      PrivatesolveSpeed: [],

      startDate: new Date(),
      endDate: new Date(),
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    refresh() {
      this.PublicsolveSpeed = [];
      this.PublicavgBidGraph = [];
      this.PublicfreeSolversGraph = [];
      this.PublicsolversOnlineGraph = [];

      this.PrivatesolveSpeed = [];
      this.PrivateavgBidGraph = [];
      this.PrivatefreeSolversGraph = [];
      this.PrivatesolversOnlineGraph = [];
      this.loadData();
    },

    async loadData() {
      await this.sleep(50);
      this.$refs.captchaStatsGraphs.style = "transform: scale(1) !important";
      this.startDate = moment(this.startDate).subtract(1, "years").format("L");
      this.endDate = moment(this.endDate).format("L");

      const response = await systemStats("Public");
      const responseSpeed = await avgSpeed(
        "reCaptcha",
        this.startDate,
        this.endDate,
        "Public"
      );
      this.PublicsolveSpeed = responseSpeed.data.datapoints;
      this.PublicavgBidGraph = response.data.graphs.avg_bid;
      this.PublicfreeSolversGraph = response.data.graphs.free_solvers;
      this.PublicsolversOnlineGraph = response.data.graphs.solvers_online;

      const responsePrivate = await systemStats("Private");
      const responseSpeedPrivate = await avgSpeed(
        "reCaptcha",
        this.startDate,
        this.endDate,
        "Private"
      );
      this.PrivatesolveSpeed = responseSpeedPrivate.data.datapoints;
      this.PrivateavgBidGraph = responsePrivate.data.graphs.avg_bid;
      this.PrivatefreeSolversGraph = responsePrivate.data.graphs.free_solvers;
      this.PrivatesolversOnlineGraph =
        responsePrivate.data.graphs.solvers_online;
    },
    activatePublic() {
      this.publicVariant = true;
      this.privateV = false;
      this.factoryV = false;
    },
    activatePrivate() {
      this.publicVariant = false;
      this.privateV = true;
      this.factoryV = false;
    },
    activateFactory() {
      this.publicVariant = false;
      this.privateV = false;
      this.factoryV = true;
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style scoped>
.captcha-solving-stats-table-main {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  height: 980px;
  background: radial-gradient(
    100% 100% at 44.04% 0%,
    #26292e85 0%,
    #1a1c1f 100%
  );
  mix-blend-mode: normal;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.0835883), inset 0px 1px 3px #000000;
  border-radius: 7px;
  transform: scale(0.5);
  transition: 0.4s;
}
.captcha-solving-stats-container {
  height: 100%;
  width: 95%;
  margin: auto;
  margin-top: 24px;
}
.captcha-solving-stats-header {
  display: flex;
  justify-content: space-between;
}

.captcha-solving-stats-header-column {
  display: flex;
  flex-direction: column;
}
.captcha-solving-stats-header-column > h1 {
  color: #e0e0e0;
  font-size: 20px;
  font-family: "OpenSans-SemiBold";
}

.captcha-solving-stats-header-column > p {
  color: #888888;
  font-size: 12px;
  margin-top: 4px;
}
.captcha-solving-stats-refresh {
  color: #888888;
  font-size: 10px;
  cursor: pointer;
}

.captcha-solving-stats-actual-graphs {
  display: flex;
  background-color: #131517;
  height: 850px;
  width: 100%;
  flex-direction: column;
  border-radius: 10px;
  overflow: auto;
  margin-bottom: 24px;
}
.captcha-solving-stats-actual-graphs > div {
  height: 850px;

}
.captcha-solving-stats-variants {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 24px;
}
.captcha-solving-stats-variants > div {
  margin-left: 20px;
  margin-right: 20px;
  text-align: center;
  cursor: pointer;
}
.captcha-solving-stats-active-variant {
  width: 65px;
  height: 2px;
  background-color: #eddb51;
}
.captcha-solving-active {
  color: #ffffff !important;
  font-family: "OpenSans-SemiBold";
  font-size: 12px;
  text-align: center !important;
}
.captcha-solving-inactive {
  color: #888888;
  font-size: 12px;
  width: 65px;
  text-align: center !important;
}
.captcha-solving-stats-actual-graphs-row {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  margin-top: 24px;
}

@media only screen and (max-width: 790px) {
  .captcha-solving-stats-actual-graphs-row {
    flex-wrap: wrap !important;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
  }
  .stats-graph-main {
    flex: 90% !important;
    max-width: 90% !important;
    width: 90% !important;
    margin: auto;
    margin-top: 16px;
  }
}
</style>
